import type { SearcherItem } from 'shared/searchers';

/** Accion names that are always plain links — they have no form on this site. */
export const LINK_SEARCHER_IDS = ['autos', 'actividades', 'traslados', 'hoteles'] as const;

export type LinkSearcherId = (typeof LINK_SEARCHER_IDS)[number];

/** Tab id for each accion. Hotels URL cannot reuse `hoteles` (that id is the BM form). */
const LINK_SEARCHER_TAB_ID: Record<LinkSearcherId, string> = {
  autos: 'autos',
  actividades: 'actividades',
  traslados: 'traslados',
  hoteles: 'hoteles-url',
};

export interface AccionAplicacion {
  name?: string;
  url?: string | null;
  activo?: boolean;
}

/**
 * Turns the tenant's `accionesAplicacion` rows into url-only searcher tabs.
 *
 * Same source the legacy FeatureSelector uses for its Autos/Actividades/
 * Traslados/Hoteles-URL buttons, so a published hero offers exactly the same
 * external links the legacy header did.
 */
export function toLinkSearchers(acciones: AccionAplicacion[] | undefined): SearcherItem[] {
  const rows = Array.isArray(acciones) ? acciones : [];

  return LINK_SEARCHER_IDS.reduce<SearcherItem[]>((items, id) => {
    const accion = rows.find((row) => row?.name === id);
    const url = accion?.url?.trim();

    if (!accion?.activo || !url) return items;

    return [...items, { id: LINK_SEARCHER_TAB_ID[id], show: true, url, urlOnly: true }];
  }, []);
}
